module.exports = __webpack_public_path__ + "img/21.heavy-wind-light.c6e60c6d.svg";